import { Constants } from "./../../shared/Helpers/constants";
import { Component, DoCheck, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UserService } from "../../_services";
import { SharedService } from "../../shared/shared.service";
import { Alert, AlertTypeEnum } from "src/app/shared/Helpers/Alert";

@Component({
  selector: "account-confirmation",
  templateUrl: "./account-confirmation.html",
})
export class AccountConfirmationComponent implements OnInit, DoCheck {
  public showLoading: boolean = true;
  public accountConfirmed: boolean = true;
  public logoPath: any;
  private token: string;
  private tenant: string;
  private userId: string;

  constructor(
    private _activedRoute: ActivatedRoute,
    private _userService: UserService,
    private sharedService: SharedService
  ) {
    this.tenant = this._activedRoute.snapshot.paramMap.get("tenant");
    this.token = this._activedRoute.snapshot.paramMap.get("token");
    this.userId = this._activedRoute.snapshot.paramMap.get("userId");
  }

  ngOnInit(): void {
    this._userService.accountConfiramtion(this.token, this.tenant, this.userId).subscribe({
      next: (res) => {
        this.showLoading = false;
        this.accountConfirmed = true;
      },
      error: (err) => {
        this.showLoading = false;
        this.accountConfirmed = false;
        const errorMessage: string = `Sorry, this link has expired. Please contact your your organisation's Able+ administrator, to request a new confirmation link.`;
        Alert.basicNotification(AlertTypeEnum.Error, "Account confirm error", errorMessage);
      }
    });
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        } else {
          this.logoPath = Constants.logoPath;
        }
      } else {
        this.logoPath = Constants.logoPath;
      }
    } else {
      this.logoPath = Constants.logoPath;
    }
  }
}
